"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.SupportRepository = {
    getSupportUrl: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/support');
        return response.data;
    },
    getWorkflowConfig: ({ companyId }) => httpRepository_1.default.tradeshiftGo()
        .get(`/rest/company/${companyId}/workflowConfig/`)
        .then(response => response.data),
    setWorkflowConfig: ({ companyId, configId }) => httpRepository_1.default.tradeshiftGo().put(`/rest/company/${companyId}/workflowConfig/${configId}`),
    getWorkflowConfigs: () => httpRepository_1.default.tradeshiftGo()
        .get('/rest/workflowConfigs/')
        .then(response => response.data),
};
